import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const FAREWELL_ACCESS_KEY = 'farewell_access_gate';
const FAREWELL_ACCESS_MAX_AGE_MS = 30 * 60 * 1000;

export default function Protected({ children }: { children: JSX.Element }) {
  const { loading, user } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'hsl(var(--bg-app))' }}>
        <div className="text-ivory/60">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    // Check if user just submitted a deletion request — redirect to /farewell not /signin
    try {
      const rawGate = sessionStorage.getItem(FAREWELL_ACCESS_KEY);
      if (rawGate) {
        const parsed = JSON.parse(rawGate);
        if (parsed?.createdAt && Date.now() - parsed.createdAt < FAREWELL_ACCESS_MAX_AGE_MS) {
          return <Navigate to="/farewell" replace />;
        }
      }
    } catch { /* ignore */ }

    // Preserve intended destination so we can redirect back after sign-in
    try {
      const intended = window.location.pathname + window.location.search;
      if (intended && intended !== '/signin') {
        sessionStorage.setItem('exora_auth_return_to', intended);
      }
    } catch { /* ignore */ }

    return <Navigate to="/?signin=true" replace />;
  }
  
  return children;
}
